import { render } from "./CurrencySelect.vue?vue&type=template&id=3a7186f0&scoped=true"
import script from "./CurrencySelect.vue?vue&type=script&lang=js"
export * from "./CurrencySelect.vue?vue&type=script&lang=js"

import "./CurrencySelect.vue?vue&type=style&index=0&id=3a7186f0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a7186f0"

export default script